module.exports = __webpack_public_path__ + "static/media/Spy.62502b7f.jpg";